import { render, staticRenderFns } from "./Profile.html?vue&type=template&id=2781f7f4&scoped=true&"
import script from "./Profile.ts?vue&type=script&lang=ts&"
export * from "./Profile.ts?vue&type=script&lang=ts&"
import style0 from "./Profile.css?vue&type=style&index=0&id=2781f7f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2781f7f4",
  null
  
)

export default component.exports